var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"py-4"},[_c('v-skeleton-loader',{attrs:{"type":"table-heading, divider, table-tbody, table-tfoot"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }